<footer class="footer">
    <div class="footer-middle">
        <div class="container">
            <div class="footer-ribbon">
                Get in touch
            </div><!-- End .footer-ribbon -->
            <div class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="widget">
                                <ul class="contact-info">
                                    <li>
                                        <span class="contact-info-label">Address:</span>{{ storeInfo?.StoreAddress }},
                                        {{ storeInfo?.CityName }}, {{ storeInfo?.CountryName }}
                                    </li>
                                    <li>
                                        <span class="contact-info-label">Phone:</span> <a href="tel:">{{
                                            storeInfo?.PhoneNo }}</a>
                                    </li>
                                    <li>
                                        <span class="contact-info-label">Email:</span> <a
                                            [href]="'mailto:'+storeInfo?.Email">{{ storeInfo?.Email }}</a>
                                    </li>
                                    <!-- <li>
                                        <span class="contact-info-label">Working Days/Hours:</span>
                                        Mon - Sun / 9:00AM - 8:00PM
                                    </li> -->
                                </ul>
                            </div><!-- End .widget -->
                        </div><!-- End .col-md-5 -->
                        <div class="col-md-2">
                            <div class="widget">
                                <h4 class="widget-title">My Account</h4>

                                <ul class="links">
                                    <li><a [routerLink]="['/about-us']">About Us</a></li>
                                    <li><a [routerLink]="['/contact-us']">Contact Us</a></li>
                                    <li *ngIf="!IsHidePrice"><a [routerLink]="['/account']">My Account</a></li>
                                    <li><a [routerLink]="['/account']">Orders History</a></li>
                                    <li *ngIf="!IsHidePrice"><a [routerLink]="['/authentication']"
                                            class="login-link">Login</a></li>
                                </ul>
                            </div><!-- End .widget -->
                        </div><!-- End .col-md-3 -->

                        <div class="col-md-2">
                            <div class="widget">
                                <h4 class="widget-title">Policy</h4>

                                <ul class="links">
                                    <li><a [routerLink]="['/info/return']">Return</a></li>
                                    <li><a [routerLink]="['/info/refund']">Refund</a></li>
                                    <li><a [routerLink]="['/info/terms']">Terms Of Use</a></li>
                                    <li><a [routerLink]="['/info/privacy']">Privacy</a></li>
                                </ul>
                            </div><!-- End .widget -->
                        </div><!-- End .col-md-3 -->

                        <div class="col-md-2">
                            <div class="widget">
                                <h4 class="widget-title">Goods & Services</h4>

                                <ul class="links">
                                    <li><a [routerLink]="['/info/goodsservice']">Goods & Services</a></li>
                                </ul>
                            </div><!-- End .widget -->
                        </div><!-- End .col-md-3 -->
                    </div><!-- End .row -->
                </div><!-- End .col-lg-8 -->
            </div><!-- End .row -->
        </div><!-- End .container -->
    </div><!-- End .footer-middle -->

    <div class="container">
        <div class="footer-bottom">
            <p class="footer-copyright">Enora &copy; 2021. All Rights Reserved</p>
            <img src="assets/images/payments.png" alt="payment methods" class="footer-payments">

            <div class="social-icons">
                <a class="social-icon" target="_blank"><i class="icon-facebook"></i></a>
                <a class="social-icon" target="_blank"><i class="icon-twitter"></i></a>
            </div><!-- End .social-icons -->
        </div><!-- End .footer-bottom -->
    </div><!-- End .containr -->
</footer><!-- End .footer -->